export default "__VITE_ASSET__2a0928db__"